module.exports = __webpack_public_path__ + "static/media/test-front.fdc52540.png";